import { Component, OnInit } from '@angular/core';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { DateRangePipe } from 'src/app/tools/pipes/date-range-pipe';
import { Location } from '@angular/common';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { ProductPage } from 'src/app/assabil-kernel/models/entities/control-tables/product-page';
import { Sinvoice } from 'src/app/assabil-sales/models/entities/s-invoice';
import { SinvoiceLine } from 'src/app/assabil-sales/models/entities/s-invoice-line';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { ToastrService } from 'ngx-toastr';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { SalesTransactionsService } from 'src/app/assabil-sales/services/sales-transactions-service';
import { ConfigService } from 'src/app/tools/services/config.service';
import { SalesReportsService } from 'src/app/assabil-sales/services/sales-reports-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';

@Component({
  selector: 'branch-invoicing',
  templateUrl: './branch-invoicing.component.html',
  styleUrls: ['./branch-invoicing.component.scss']
})
export class BranchInvoicingComponent implements OnInit {

  simulationDate      : Date          = new Date();
  partner             : Partner       = new Partner();
  productPages        : ProductPage[] = [];
  sinvoice            : Sinvoice      = new Sinvoice();
  validationStep      : boolean       = false;


  enteredOnly         : boolean       = false;
  qColumns  = [
    {'label' : 'Quantité',          readOnly : false, background :'#eef5fb'}, 
    {'label' : 'Retour',            readOnly : false, background :'#eef5fb'},  
    {'label' : 'Retour Endommagé',  readOnly : false, background :'#faeeee'}, 
    {'label' : 'Retour Périmé',     readOnly : false, background :'#f0dede'},  
  ];

  partnerLovComponent = PartnerLovComponent;
  
  constructor(
    protected baseService     : BaseService,
    protected masterDataService: MasterDataService,
    protected promoService    : PromoService,
    protected salesTransactionsService : SalesTransactionsService,
    protected location        : Location,
    protected toastr          : ToastrService,
    protected leanUtilsService : LeanUtilsService,
    protected dateRangePipe   : DateRangePipe,
    protected salesReportsService : SalesReportsService,
    protected configService   : ConfigService) {
    }


      
//-----------------------------------------------------------------------------------------------------------------------------
productCode   : string;
salableOnly   : boolean = true;
includingHold : boolean = false;

ngOnInit() {
  this.masterDataService.loadProductPages(1, true).then(res => {
    this.productPages = this.masterDataService.salableProductPages;
  });
}
//-----------------------------------------------------------------------------------------------------------------------------




//-----------------------------------------------------------------------------------------------------------------------------
simulate(){

  if (this.partner.partnerCode == null) {
    this.toastr.error("Priere de définir le client à considérer pour le test des promotions");
    return;
  }

  let sinvoice : Sinvoice = new Sinvoice();
  let tmp : Partner = new Partner();
  tmp.partnerCode = this.partner.partnerCode;
  sinvoice.partner = tmp;
  sinvoice.periodActiveDay = this.simulationDate;
  sinvoice.sinvoiceLines = [];
  this.productPages.forEach(pp => {
      pp.products.forEach(p => {
        if (p.quantityP[0] == null)  p.quantityP[0] = 0;     // TODO
        if (p.quantityU[0] == null)  p.quantityU[0] = 0;
            if (p.quantityP[1] == null)  p.quantityP[1] = 0;     // TODO
            if (p.quantityU[1] == null)  p.quantityU[1] = 0;
            if (p.quantityP[2] == null)  p.quantityP[2] = 0;     // TODO
            if (p.quantityU[2] == null)  p.quantityU[2] = 0;
            if (p.quantityP[3] == null)  p.quantityP[3] = 0;     // TODO
            if (p.quantityU[3] == null)  p.quantityU[3] = 0;
              if (p.quantityP[0] || p.quantityU[0] || p.quantityP[1] || p.quantityU[1] ||
                  p.quantityP[2] || p.quantityU[2] || p.quantityP[3] || p.quantityU[3]) {
              let sinvoiceLine : SinvoiceLine = new SinvoiceLine();
              sinvoiceLine.product = new Product();
              sinvoiceLine.sinvoiceLineNumber         = 0; // required, otherwise Json parsing pb on server side !!
              sinvoiceLine.product.productCode      = p.productCode;
              sinvoiceLine.product.name             = p.name;
              sinvoiceLine.quantity                 = p.quantityP[0] * p.salesPacking +  p.quantityU[0] ;
              sinvoiceLine.returnedQuantity         = p.quantityP[1] * p.salesPacking +  p.quantityU[1];
              sinvoiceLine.returnedDamagedQuantity1 = p.quantityP[2] * p.salesPacking +  p.quantityU[2];
              sinvoiceLine.returnedDamagedQuantity2 = p.quantityP[3] * p.salesPacking +  p.quantityU[3]; 
              sinvoiceLine.unitPrice                = p.salesPrice;
              sinvoiceLine.freeGoodLine             = false;
              sinvoice.sinvoiceLines.push(sinvoiceLine);
          }
      })
  })

this.simulatedInvoice = sinvoice;
  this.salesTransactionsService.sinvoiceSimulate(sinvoice).then(result => {
      this.sinvoice = result;
      this.validationStep = true;
  })
}
//-----------------------------------------------------------------------------------------------------------------------------

simulatedInvoice : Sinvoice;
//-----------------------------------------------------------------------------------------------------------------------------
validate(){
  this.salesTransactionsService.sinvoiceCreate(this.simulatedInvoice).then(result => {
    this.sinvoice = result;
    this.validationStep = false;
    this.leanUtilsService.success();
    this.productPages.forEach(pp => {
      pp.products.forEach(p => {
        p.quantityP[0] = null;
        p.quantityU[0] = null;
        p.quantityP[1] = null;
        p.quantityU[1] = null;
        p.quantityP[2] = null;
        p.quantityU[2] = null;
        p.quantityP[3] = null;
        p.quantityU[3] = null;
      })
    })
  })
}
//-----------------------------------------------------------------------------------------------------------------------------

//-----------------------------------------------------------------------------------------------------------------------------
 close(){
  this.location.back();
 }
//-----------------------------------------------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------
print(){
  this.salesReportsService.sinvoicePrint(this.sinvoice.sinvoiceCode);
  }
//---------------------------------------------------------------------------------------


}
